import api from '@/api/apScheduler'

const state = {

}

const actions = {
  getSchedulerJobList (context, params) {
    return api.getSchedulerJobList(params)
  },
  getSchedulerJobDetail (context, params) {
    return api.getSchedulerJobDetail(params)
  },
  getJobSyncDetailInfo (context, params) {
    return api.getJobSyncDetailInfo(params)
  },
  getApplicationSyncDetailInfo (context, params) {
    return api.getApplicationSyncDetailInfo(params)
  },
  getApplicationStatusSyncDetailInfo (context, params) {
    return api.getApplicationStatusSyncDetailInfo(params)
  },
  getSchedulerStatus (context) {
    return api.getSchedulerStatus()
  },
  getSchedulerCount (context, params) {
    return api.getSchedulerCount(params)
  },
  setSchedulerTaskInfo (context, params) {
    return api.setSchedulerTaskInfo(params)
  },
  batchSetSchedulerTaskInfo (context) {
    return api.batchSetSchedulerTaskInfo()
  },
  getIntegrationCompany (context) {
    return api.getIntegrationCompany()
  },
  getJobSyncDetailInfoByHistoryId (context, historyId) {
    return api.getJobSyncDetailInfoByHistoryId(historyId)
  },
  getApplicationSyncDetailInfoByHistoryId (context, historyId) {
    return api.getApplicationSyncDetailInfoByHistoryId(historyId)
  },
  getApplicationStatusSyncDetailInfoByHistoryId (context, historyId) {
    return api.getApplicationStatusSyncDetailInfoByHistoryId(historyId)
  },
  getEmployeeSyncDetailInfoByHistoryId (context, historyId) {
    return api.getEmployeeSyncDetailInfoByHistoryId(historyId)
  },
  retryApplicationIntegration (context, params) {
    return api.retryApplicationIntegration(params)
  },
  createExportApplicationSyncRecordTask (context, params) {
    return api.createExportApplicationSyncRecordTask(params)
  },
  getExportApplicationSyncRecordTaskInfo (context, params) {
    return api.getExportApplicationSyncRecordTaskInfo(params)
  },
  createExportApplicationStatusSyncRecordTask (context, params) {
    return api.createExportApplicationStatusSyncRecordTask(params)
  },
  getExportApplicationStatusSyncRecordTaskInfo (context, params) {
    return api.getExportApplicationStatusSyncRecordTaskInfo(params)
  },
  getIntegrationErrorRecordList (context, params) {
    return api.getIntegrationErrorRecordList(params)
  },
  markIntegrationErrorRecordProcessed (context, params) {
    return api.markIntegrationErrorRecordProcessed(params)
  },
  createExportIntegrationErrorRecordTask (context, params) {
    return api.createExportIntegrationErrorRecordTask(params)
  },
  getExportIntegrationErrorRecordTaskInfo (context, params) {
    return api.getExportIntegrationErrorRecordTaskInfo(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
